/* Custom loop-safe position indicator for the redesigned PDP gallery.
   Swiper's own pagination module desyncs with loop:true in this theme's
   build (blank slides, phantom bullets), so the dots are rendered and
   driven here off swiper.realIndex instead.
   On the multi-scent extrait template, swatch-gallery.js filters the slide
   set per scent (appendSlide/removeSlide) after init — the dots rebuild on
   slidesLengthChange so the count always matches the visible slides. */
(function () {
  function init() {
    var medias = document.querySelectorAll('.pdp-redesign-gallery swiper-content.main--product-media');
    medias.forEach(function (media) {
      var tries = 0;
      /* on multi-scent pages (fragrance picker present) swatch-gallery.js
         filters the slide set right after load — hold the first dots build
         until that filter has run (2.5s fallback) so the dots never flash
         the full unfiltered count. The config script alone isn't the signal:
         it also renders on single-scent pages where SwatchGallery stays
         disabled and the filter never runs. */
      var scentPicker = document.querySelector('[data-fragrance-swatches]');
      (function wait() {
        var swiper = media.swiper;
        var dots = media.querySelector('.pdp-dots');
        var sg = window.SwatchGalleryInstance;
        var filterPending = scentPicker && !(sg && sg.initialSwapDone) && tries < 25;
        if (!swiper || !dots || filterPending) {
          if (tries++ < 40) setTimeout(wait, 100);
          return;
        }
        if (dots.dataset.ready) return;
        dots.dataset.ready = 'true';
        var bullets = [];
        function paint() {
          for (var j = 0; j < bullets.length; j++) {
            bullets[j].classList.toggle('swiper-pagination-bullet-active', j === swiper.realIndex);
          }
        }
        function build() {
          if (bullets.length === swiper.slides.length) {
            paint();
            return;
          }
          dots.innerHTML = '';
          bullets = [];
          for (var i = 0; i < swiper.slides.length; i++) {
            (function (idx) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'swiper-pagination-bullet';
              b.setAttribute('aria-label', 'Go to image ' + (idx + 1));
              b.addEventListener('click', function () {
                swiper.slideToLoop(idx);
              });
              dots.appendChild(b);
              bullets.push(b);
            })(i);
          }
          paint();
        }
        swiper.on('slideChange', paint);
        /* this theme's Swiper build never emits slidesLengthChange — 'update'
           is what actually fires when swatch-gallery.js swaps the slide set
           (build() early-exits to a repaint when the count is unchanged) */
        swiper.on('slidesLengthChange', build);
        swiper.on('update', build);
        build();
      })();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Olfactive-notes + title-head variant swap. The multi-scent templates switch
   variants through the swatch gallery's custom `variant:change` event, not
   through a <variants-set> element, so variant-dropdown-enhanced.js's node
   swaps never run there — the notes slot and the title head (variant name +
   price/volume) are refetched and swapped here instead. */
(function () {
  var pending = 0;
  /* Variant-sourced accordions (ingredients, scent notes, …): each live
     [data-variant-metafield] body pulls its key's content for the new scent
     out of `root` (a cache template's .pdp-swap-mf divs, or a fetched
     section's own accordion bodies). A scent with no value for a key hides
     that accordion instead of keeping the previous scent's content. */
  function swapVariantMetafields(root) {
    document.querySelectorAll('[data-variant-metafield]').forEach(function (el) {
      var key = el.getAttribute('data-variant-metafield');
      var src = root && root.querySelector('.pdp-swap-mf[data-mf="' + key + '"], [data-variant-metafield="' + key + '"]');
      var has = !!(src && src.textContent.trim() !== '');
      var wrap = el.closest('.product-accordion');
      el.innerHTML = has ? src.innerHTML : '';
      if (wrap) wrap.style.display = has ? '' : 'none';
    });
  }
  function onVariantChange(e) {
    var slot = document.querySelector('.pdp-notes-slot');
    if (!slot || !slot.id) return;
    var vid = e && e.detail && (e.detail.variantId || (e.detail.variant && e.detail.variant.id));
    if (!vid) {
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      vid = m && m[1];
    }
    if (!vid) return;
    var req = ++pending;
    var sectionId = slot.id.replace('pdp-notes-slot-', '');
    /* Cache-first: the hero template pre-renders every variant's notes panel
       into inert <template> elements (product-details.liquid) so flicking
       through scents swaps instantly instead of waiting on a section
       re-render round-trip per click. */
    var tpl = document.querySelector('template[data-pdp-swap-variant="' + vid + '"]');
    if (tpl) {
      var cachedSlot = tpl.content.querySelector('.pdp-notes-slot');
      if (cachedSlot) slot.innerHTML = cachedSlot.innerHTML;
      var head = document.getElementById('pdp-title-head-' + sectionId);
      if (head) {
        var nameEl = head.querySelector('.pdp-title-stack a');
        if (nameEl && tpl.dataset.title) nameEl.textContent = tpl.dataset.title;
        var priceEl = head.querySelector('.pdp-tp-price');
        if (priceEl && tpl.dataset.price) priceEl.textContent = tpl.dataset.price;
      }
      swapVariantMetafields(tpl.content);
      return;
    }
    fetch(window.location.pathname + '?variant=' + vid + '&section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        if (req !== pending) return;
        var html = new DOMParser().parseFromString(text, 'text/html');
        var src = html.getElementById(slot.id);
        if (src) slot.innerHTML = src.innerHTML;
        var titleHead = document.getElementById('pdp-title-head-' + sectionId);
        var titleSrc = titleHead && html.getElementById(titleHead.id);
        if (titleSrc) titleHead.innerHTML = titleSrc.innerHTML;
        swapVariantMetafields(html);
      })
      .catch(function () {});
  }
  document.addEventListener('variant:change', onVariantChange);
})();

/* Sticky-card containment (edp-hero). The card rides inside an absolute rail
   (theme.css: top 42px / bottom 120px of the product section), but CSS sticky
   lets an element TALLER than its rail overflow past it — on short viewports
   the hero section is just the gallery, so the card spilled over the marquee
   and the featured collection below. Keep the section at least tall enough
   (rail top + card height + rail bottom gap) for the card to settle inside. */
(function () {
  var rail, card, sectionWrap, ro;
  function apply() {
    if (!rail || !card || !sectionWrap) return;
    var railStyle = getComputedStyle(rail);
    if (window.matchMedia('(min-width: 1025px)').matches && railStyle.position === 'absolute') {
      var bottomGap = parseFloat(railStyle.bottom) || 0;
      sectionWrap.style.minHeight = Math.ceil(rail.offsetTop + card.offsetHeight + bottomGap) + 'px';
    } else {
      sectionWrap.style.minHeight = '';
    }
  }
  function init() {
    rail = document.querySelector('.main--product-content-wrapper.pdp-hero');
    card = rail && rail.querySelector('.main--product-content');
    sectionWrap = rail && rail.closest('.section-wrapper');
    if (!rail || !card || !sectionWrap) return;
    apply();
    /* card height changes with scent swaps / bundle picks, not just resize */
    if (window.ResizeObserver) {
      ro = new ResizeObserver(apply);
      ro.observe(card);
    }
    window.addEventListener('resize', apply);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
